import React, { useState, useEffect } from 'react';
import {
    Button,
    Dropdown,
    Modal,
    Menu,
    Layout,
    List,
    Checkbox,
    Switch,
    Input,
    Form,
    Select,
    Space,
    Divider,
    Card,
    Typography,
    Row,
    Col,
    message
} from 'antd';
import {
    HeartOutlined,
    DownOutlined,
    PlusOutlined,
    BarChartOutlined,
    TableOutlined,
    CommentOutlined,
    FilterOutlined,
    AppstoreOutlined,
    EditOutlined,
    DeleteOutlined
} from '@ant-design/icons';
import { Edit } from 'lucide-react';
import FilterTags from '@/pages/Ownerpage/Charts/FilterTags';
import ChartFilter from '@/pages/Ownerpage/Charts/ChartFilter';
import chartService from '@/services/chartService';

const { Sider, Content } = Layout;
const { Text, Title } = Typography;
const { TextArea } = Input;

const FavoriteListComponent = ({ chartGroups, filterOptions, reportType, setFavouriteSetting }) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingFavorite, setEditingFavorite] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState('all-charts');
    const [favoriteSettings, setFavoriteSettings] = useState({});
    const [allChartsSettings, setAllChartsSettings] = useState({
        showTable: false,
        showComments: false,
        selectedComments: []
    });
    const [allFavourites, setAllFavorite] = useState([])
    const [isDropdownVisible, setIsDropdownVisible] = useState(false);
    const [filteredProcessdata, setFilterProcessData] = useState({
        ship_id: "",
        date: null,
        eu_noneu: { from: "", to: "" },
        events: [],
        voyage: null,
    });


    console.log("chartGroups", chartGroups)

    // Get all charts from all groups
    const getAllCharts = () => {
        return chartGroups.reduce((acc, group) => {
            return [...acc, ...group.charts];
        }, []);
    };

    // Get comments for a specific chart
    const getCommentsForChart = (chartId) => {
        const allCharts = getAllCharts();
        const chart = allCharts.find(c => c.id === chartId);
        if (chart && chart.chart_comments) {
            return chart.chart_comments.map(comment => ({
                value: comment.id,
                label: comment.comments
            }));
        }
        return [];
    };

    const handleCreateNew = () => {
        // Reset all states for new favorite
        setIsEditMode(false);
        setEditingFavorite(null);
        setSelectedGroup('all-charts');
        setFavoriteSettings({});
        setAllChartsSettings({
            showTable: false,
            showComments: false,
            selectedComments: []
        });
        setIsModalVisible(true);
        setIsDropdownVisible(false);
    };

    const handleSelectFavorite = (favoriteIndex) => {
        setIsDropdownVisible(false);
        const favorite = allFavourites?.find(x => x?.id == favoriteIndex);
        setFavouriteSetting(favorite)
    }

    const handleEditFavorite = (favoriteIndex) => {
        const favorite = allFavourites?.find(x => x?.id == favoriteIndex)
        // Load existing favorite data (you would fetch this from your backend)
        const existingFavoriteData = {
            name: favorite,
            chartSettings: {
                // Example of loading existing settings - replace with actual data from backend
                'me-work-kwh': { showTable: true, showComments: false, selectedComments: ['performance'] },
                'fuel-consumption': { showTable: false, showComments: true, selectedComments: ['efficiency', 'maintenance'] }
            },
            selectedGroup: 'main-engine',
            allChartsSettings: {
                showTable: false,
                showComments: true,
                selectedComments: ['performance', 'efficiency']
            }
        };

        // Set the states with existing data
        setIsEditMode(true);
        setEditingFavorite({ name: favorite, index: favoriteIndex });
        setSelectedGroup(existingFavoriteData.selectedGroup);
        setFavoriteSettings(existingFavoriteData.chartSettings);
        setAllChartsSettings(existingFavoriteData.allChartsSettings);
        setIsModalVisible(true);
        setIsDropdownVisible(false);
    };
console.log("jhkjhk",isDropdownVisible)
     const CustomDropdown = () => (
    <div style={{ position: 'relative', display: 'inline-block' }}>
        <Button
            type="primary"
            style={{ backgroundColor: '#06A786', borderColor: '#06A786' }}
            onClick={() => setIsDropdownVisible(!isDropdownVisible)}
        >
            <HeartOutlined style={{ color: 'white', marginRight: 6 }} />
            Favorite
            <DownOutlined style={{ color: 'white', fontSize: 12, marginLeft: 6 }} />
        </Button>

        {isDropdownVisible && (
            <>
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        zIndex: 999
                    }}
                    onClick={() => setIsDropdownVisible(false)}
                />

                <div
                    style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        backgroundColor: 'white',
                        border: '1px solid #d9d9d9',
                        boxShadow:
                            '0 6px 16px rgba(0,0,0,0.08), 0 3px 6px rgba(0,0,0,0.12), 0 9px 28px rgba(0,0,0,0.05)',
                        minWidth: '300px',
                        zIndex: 1000
                    }}
                >
                    {/* Create Favourite */}
                    <div
                        style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            borderBottom: '1px solid #f0f0f0'
                        }}
                        onClick={handleCreateNew}
                        onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = '#f5f5f5')
                        }
                        onMouseLeave={(e) =>
                            (e.currentTarget.style.backgroundColor = 'white')
                        }
                    >
                        <PlusOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                        <span>Create Favourite</span>
                    </div>

                    {allFavourites.map((fav, index) => (
                        <div
                            key={index}
                            style={{
                                padding: '8px 12px',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                borderBottom:
                                    index < allFavourites.length - 1
                                        ? '1px solid #f0f0f0'
                                        : 'none'
                            }}
                            onMouseEnter={(e) =>
                                (e.currentTarget.style.backgroundColor = '#f5f5f5')
                            }
                            onMouseLeave={(e) =>
                                (e.currentTarget.style.backgroundColor = 'white')
                            }
                        >
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flex: 1
                                }}
                                onClick={() => handleSelectFavorite(fav.id)}
                            >
                                <span>{fav?.favorite_name}</span>
                            </div>

                            <Edit
                                size={20}
                                className="bg-warning-subtle text-warning"
                                style={{
                                    color: '#1890ff',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    borderRadius: '4px'
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditFavorite(fav.id);
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#e6f7ff';
                                    e.stopPropagation();
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = 'transparent';
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                    ))}
                </div>
            </>
        )}
    </div>
);

    const handleDelete = () => {
        if (editingFavorite) {
            console.log('Delete favorite:', editingFavorite.name);
             setIsModalVisible(false);
            setIsEditMode(false);
            setEditingFavorite(null);
        }
    };

    const menuItems = [
        {
            key: 'create-new',
            icon: <PlusOutlined />,
            label: 'Create Favourite'
        },
        { type: 'divider' },
        ...allFavourites.map((fav, index) => ({
            key: `favorite-${fav.id}`,
            icon: <Space><EditOutlined /><HeartOutlined /></Space>,
            label: fav.favorite_name
        }))
    ];

    const handleGroupSelect = (groupId) => {
        setSelectedGroup(groupId);
    };

    const handleChartSettingsChange = (chartId, setting, value) => {
        console.log("value", value)
        setFavoriteSettings(prev => ({
            ...prev,
            [chartId]: {
                ...prev[chartId],
                [setting]: value
            }
        }));
    };

    // Handle All Charts master controls
    const handleAllChartsSettingsChange = (setting, value) => {
        setAllChartsSettings(prev => ({
            ...prev,
            [setting]: value
        }));

        // Apply to all charts since all are selected by default
        const allCharts = getAllCharts();
        allCharts.forEach(chart => {
            handleChartSettingsChange(chart.id, setting, value);
        });
    };

    const handleSubmit = async () => {
        // Basic validation
        const nameInput = document.querySelector('input[placeholder="Enter favourite name"]');
        if (!nameInput?.value) {
            alert('Please enter a favourite name');
            return;
        }

        const finalSettings = {
            favoriteName: nameInput.value,
            filteredProcessdata: filteredProcessdata,
            chartSettings: favoriteSettings,
            editingIndex: editingFavorite?.index
        };
        console.log("finalSettingsfinalSettings", finalSettings)
        if (isEditMode) {
            console.log('Update favorite settings:', finalSettings);
        } else {
            const savesetttings = await chartService.addChartfavouritesettings(finalSettings)
            message.success("Favourite created successfully")
            console.log('Create favorite settings:', savesetttings);
        }

        handleCloseModal();
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setFavoriteSettings({});
        setAllChartsSettings({
            showTable: false,
            showComments: false,
            selectedComments: []
        });
        setIsEditMode(false);
        setEditingFavorite(null);
        setSelectedGroup('all-charts');
    };

    const selectedGroupData = chartGroups.find(group => group.id === selectedGroup);
    const getallfavouites = async () => {
        const allfavourties = await chartService.getallFavourites();
        console.log("allfavourtiesallfavourties", allfavourties?.displaydata)
        setAllFavorite(allfavourties?.displaydata)
    }
    useEffect(() => {
        getallfavouites()
    }, [isModalVisible])
    // Extended menu items with All Charts option
    const extendedMenuItems = [
        {
            key: 'all-charts',
            icon: <AppstoreOutlined />,
            label: 'All Charts'
        },
        ...chartGroups.map(group => ({
            key: group.id,
            label: group.name
        }))
    ];

    return (
        <div className="favorite-list-container">
            <CustomDropdown />

            <Modal
                title={isEditMode ? `Edit Favourite - ${editingFavorite?.name}` : "Create Favourite"}
                open={isModalVisible}
                onCancel={handleCloseModal}
                width={1200}
                footer={[
                    <Button key="cancel" onClick={handleCloseModal}>
                        Cancel
                    </Button>,
                    ...(isEditMode ? [
                        <Button
                            key="delete"
                            danger
                            icon={<DeleteOutlined className='text-danger' />}
                            onClick={handleDelete}
                            style={{ marginRight: 'auto' }}
                        >
                            Delete Favourite
                        </Button>
                    ] : []),
                    <Button key="submit" type="primary" onClick={handleSubmit}>
                        {isEditMode ? 'Update Favourite' : 'Save Favourite'}
                    </Button>
                ]}
            >
                <div style={{ marginBottom: '24px' }}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
                            Favourite Name *
                        </label>
                        <Input
                            placeholder="Enter favourite name"
                            defaultValue={isEditMode ? editingFavorite?.name : ''}
                        />
                    </div>

                    {/* Filter */}
                    <div style={{
                        backgroundColor: '#1b9b81ff',
                        padding: '16px',
                        borderRadius: '6px',
                        marginBottom: '16px'
                    }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '12px',
                            color: 'white'
                        }}>
                            <FilterOutlined style={{ marginRight: '8px' }} />
                            <Text style={{ color: 'white', fontWeight: '500' }}>Filter Options</Text>
                        </div>
                        <ChartFilter
                            setFilterProcessData={setFilterProcessData}
                            filteredProcessdata={filteredProcessdata}
                            filterOptions={filterOptions}
                            filter_type={"FAVOURITE"}
                        />
                    </div>
                </div>

                <Layout style={{ minHeight: '500px', backgroundColor: '#f5f5f5' }}>
                    <Sider width={250} style={{ backgroundColor: 'white', borderRadius: '6px', marginRight: '16px' }}>
                        <div style={{ padding: '16px' }}>
                            <Title level={5}>Chart List</Title>
                            <Menu
                                mode="vertical"
                                selectedKeys={[selectedGroup]}
                                style={{ border: 'none' }}
                            >
                                {extendedMenuItems.map(item => (
                                    <Menu.Item
                                        key={item.key}
                                        icon={item.icon}
                                        onClick={() => handleGroupSelect(item.key)}
                                    >
                                        {item.label}
                                    </Menu.Item>
                                ))}
                            </Menu>
                        </div>
                    </Sider>

                    <Content style={{ backgroundColor: 'white', borderRadius: '6px', padding: '16px' }}>
                        {selectedGroup === 'all-charts' ? (
                            <>
                                <Title level={4} style={{ marginBottom: '16px' }}>
                                    All Charts
                                </Title>

                                {/* Master Controls */}
                                <Card style={{ marginBottom: '16px', backgroundColor: '#f0f9ff' }} size="small">
                                    <Row gutter={[16, 16]}>
                                        <Col span={24}>
                                            <div style={{ backgroundColor: '#e6f7ff', padding: '12px', borderRadius: '4px' }}>
                                                <Row gutter={[16, 12]}>
                                                    <Col span={24}>
                                                        <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                            <Text strong>Master Display Options</Text>
                                                            <Space>
                                                                <TableOutlined />
                                                                <Switch
                                                                    size="small"
                                                                    checked={allChartsSettings.showTable}
                                                                    onChange={(checked) => handleAllChartsSettingsChange('showTable', checked)}
                                                                />
                                                                <Text>Show All Tables</Text>
                                                            </Space>
                                                            <Space>
                                                                <CommentOutlined />
                                                                <Switch
                                                                    size="small"
                                                                    checked={allChartsSettings.showComments}
                                                                    onChange={(checked) => handleAllChartsSettingsChange('showComments', checked)}
                                                                />
                                                                <Text>Show All Comments</Text>
                                                            </Space>
                                                        </Space>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>

                                <Divider />

                                {/* All Charts List */}
                                <List
                                    dataSource={getAllCharts()}
                                    renderItem={(chart) => (
                                        <List.Item style={{ padding: '16px 0' }}>
                                            <Card style={{ width: '100%' }} size="small">
                                                <Row gutter={[16, 16]}>
                                                    <Col span={24}>
                                                        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
                                                            <Space>
                                                                <Text strong>{chart.name}</Text>
                                                            </Space>
                                                        </Space>
                                                    </Col>

                                                    <Col span={24}>
                                                        <div style={{ backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '4px' }}>
                                                            <Row gutter={[16, 12]}>
                                                                <Col span={12}>
                                                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                                        <Text strong>Display Options</Text>
                                                                        <Space>
                                                                            <TableOutlined />
                                                                            <Switch
                                                                                size="small"
                                                                                checked={favoriteSettings[chart.id]?.showTable || false}
                                                                                onChange={(checked) => handleChartSettingsChange(chart.id, 'showTable', checked)}
                                                                            />
                                                                            <Text>Show Table</Text>
                                                                        </Space>
                                                                        <Space>
                                                                            <CommentOutlined />
                                                                            <Switch
                                                                                size="small"
                                                                                checked={favoriteSettings[chart.id]?.showComments || false}
                                                                                onChange={(checked) => handleChartSettingsChange(chart.id, 'showComments', checked)}
                                                                            />
                                                                            <Text>Show Comments</Text>
                                                                        </Space>
                                                                    </Space>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                                        <Text strong>Comments to Include</Text>
                                                                        <Select
                                                                            mode="multiple"
                                                                            placeholder="Select comments"
                                                                            style={{ width: '100%' }}
                                                                            size="small"
                                                                            value={favoriteSettings[chart.id]?.selectedComments || []}
                                                                            onChange={(value) => handleChartSettingsChange(chart.id, 'selectedComments', value)}
                                                                            disabled={!favoriteSettings[chart.id]?.showComments}
                                                                            options={getCommentsForChart(chart.id)}
                                                                            notFoundContent={chart.chart_comments?.length === 0 ? 'No comments available' : 'No comments found'}
                                                                        />
                                                                    </Space>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </List.Item>
                                    )}
                                />
                            </>
                        ) : selectedGroupData ? (
                            <>
                                <Title level={4} style={{ marginBottom: '16px' }}>
                                    {selectedGroupData.name} Charts
                                </Title>

                                <List
                                    dataSource={selectedGroupData.charts}
                                    renderItem={(chart) => (
                                        <List.Item style={{ padding: '16px 0' }}>
                                            <Card style={{ width: '100%' }} size="small">
                                                <Row gutter={[16, 16]}>
                                                    <Col span={24}>
                                                        <Space align="center" style={{ width: '100%', justifyContent: 'space-between' }}>
                                                            <Space>
                                                                <Text strong>{chart.name}</Text>
                                                            </Space>
                                                        </Space>
                                                    </Col>

                                                    <Col span={24}>
                                                        <div style={{ backgroundColor: '#f8f9fa', padding: '12px', borderRadius: '4px' }}>
                                                            <Row gutter={[16, 12]}>
                                                                <Col span={12}>
                                                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                                        <Text strong>Display Options</Text>
                                                                        <Space>
                                                                            <TableOutlined />
                                                                            <Switch
                                                                                size="small"
                                                                                checked={favoriteSettings[chart.id]?.showTable || false}
                                                                                onChange={(checked) => handleChartSettingsChange(chart.id, 'showTable', checked)}
                                                                            />
                                                                            <Text>Show Table</Text>
                                                                        </Space>
                                                                        <Space>
                                                                            <CommentOutlined />
                                                                            <Switch
                                                                                size="small"
                                                                                checked={favoriteSettings[chart.id]?.showComments || false}
                                                                                onChange={(checked) => handleChartSettingsChange(chart.id, 'showComments', checked)}
                                                                            />
                                                                            <Text>Show Comments</Text>
                                                                        </Space>
                                                                    </Space>
                                                                </Col>

                                                                <Col span={12}>
                                                                    <Space direction="vertical" size="small" style={{ width: '100%' }}>
                                                                        <Text strong>Comments to Include</Text>
                                                                        <Select
                                                                            mode="multiple"
                                                                            placeholder="Select comments"
                                                                            style={{ width: '100%' }}
                                                                            size="small"
                                                                            value={favoriteSettings[chart.id]?.selectedComments || []}
                                                                            onChange={(value) => handleChartSettingsChange(chart.id, 'selectedComments', value)}
                                                                            disabled={!favoriteSettings[chart.id]?.showComments}
                                                                            options={getCommentsForChart(chart.id)}
                                                                            notFoundContent={chart.chart_comments?.length === 0 ? 'No comments available' : 'No comments found'}
                                                                        />
                                                                    </Space>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card>
                                        </List.Item>
                                    )}
                                />
                            </>
                        ) : null}
                    </Content>
                </Layout>
            </Modal >
        </div >
    );
};

export default FavoriteListComponent;